/* tslint:disable */
/* eslint-disable */
/**
 * ProjectOne API
 * API for Classical Conversations content and communities.  # Service URLs In local dev: - [The **local backend**](http://0.0.0.0:8080/) defaults to running on port 8080. - [The **local frontend**](http://0.0.0.0:3000/) defaults to running on port 3000.  In the DEV environment: - [The **DEV backend**](https://dev-ccp1-api.classicaltesting.net/) runs at https://dev-ccp1-api.classicaltesting.net/. - [The **DEV frontend**](https://dev-ccp1.classicaltesting.net/) runs at https://dev-ccp1.classicaltesting.net/.  The TEST environment is similar, but with `test-` instead of `dev-`.
 *
 * The version of the OpenAPI document: 40ad59d7 (Wed Jul 15 19:12:51 UTC 2026)
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { UserScreeningStatuses } from './'

/**
 * An object containing fields to update on a UserScreening record.
 * @export
 * @interface UpdateUserScreeningRequestBody
 */
export interface UpdateUserScreeningRequestBody {
  /**
   * UserScreening unique identifier
   * @type number
   * @memberof UpdateUserScreeningRequestBody
   */
  userScreeningKey: number
  /**
   *
   * @type UserScreeningStatuses
   * @memberof UpdateUserScreeningRequestBody
   */
  status: UserScreeningStatuses
}

export function UpdateUserScreeningRequestBodyFromJSON(
  json: any
): UpdateUserScreeningRequestBody {
  return UpdateUserScreeningRequestBodyFromJSONTyped(json, false)
}

export function UpdateUserScreeningRequestBodyFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): UpdateUserScreeningRequestBody {
  if (json === undefined || json === null) {
    return json
  }
  return {
    userScreeningKey: json['userScreeningKey'],
    status: json['status'],
  }
}

export function UpdateUserScreeningRequestBodyToJSON(
  value?: UpdateUserScreeningRequestBody | null
): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    userScreeningKey: value.userScreeningKey,
    status: value.status,
  }
}
